/**
 * Book Writing Toolbox's own subdomain -- bookwritingtoolbox.freedailypro.com
 * -- serves the exact same React app and backend as freedailypro.com
 * itself (same Railway service, same database, same Stripe account,
 * same user accounts). This file is the one place that decides what
 * changes when a request comes in on that hostname, so every
 * subdomain-specific behavior stays in one spot rather than scattered
 * hostname checks that could drift out of sync with each other.
 *
 * Real product decision behind this: launch fast by reusing
 * everything already built here, rather than a second codebase or
 * deployment, while still giving Book Writing Toolbox its own front
 * door and a deliberately smaller purchase surface (no AI-tier
 * pricing) than the full freedailypro.com version. Existing
 * freedailypro.com users keep both options -- the tool itself is
 * identical either way, just reached from two different domains.
 */

export const BOOK_WRITING_TOOLBOX_HOSTNAME = "bookwritingtoolbox.freedailypro.com";

/** True only on the real subdomain in a real browser -- window isn't
 *  defined during server-side/static prerendering, so this always
 *  returns false there, which is the correct default (prerendered
 *  pages are for freedailypro.com's own crawlable content, not this
 *  subdomain's variant). */
export function isBookWritingToolboxDomain(): boolean {
  return typeof window !== "undefined" && window.location.hostname === BOOK_WRITING_TOOLBOX_HOSTNAME;
}
